import { useContext } from 'react';
import EDIconButton from '../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDButton from '../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../../../BaseComponents/Icon/EDIcon';
import FakturaDelContext from '../FakturaDelContextManager/FakturaDelContext';
import { TEDLRFakturaAttestAttestTypEnum } from '../../../../../../../globalQueryTypes';
import {
  useIsMediumBreakpoint,
  useIsSmallBreakpoint,
} from '../../../../../../../Components/BreakpointContext/BreakpointContextUtils';

interface IProps {
  onClick: () => void;
}

const ShowKodBehButton = (props: IProps) => {
  const fakturaDelContext = useContext(FakturaDelContext);
  const isSmall = useIsSmallBreakpoint();
  const isMedium = useIsMediumBreakpoint();

  const attesterar = !fakturaDelContext.jagAttesterar;

  const notControlCertifier =
    fakturaDelContext.minFakturaAttest.aktuellFakturaAttest?.AttestTyp !==
    TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST;

  const disabled = attesterar || !notControlCertifier;

  return isSmall ? (
    <EDIconButton
      color="primary"
      disabled={disabled}
      icon="info"
      iconColor={disabled ? 'disabled' : undefined}
      margin="none"
      onClick={props.onClick}
      padding="dense"
      tooltip="Visa urval för kodbehörigheten"
      testId="KodbehBtn"
    />
  ) : isMedium ? (
    <EDButton
      color="primary"
      disabled={disabled}
      flat
      onClick={props.onClick}
      size="medium"
      icon={
        <EDIcon color={disabled ? 'disabled' : 'primary'} iconType="info" />
      }
      label={'Mina kodbehörigheter'}
      tooltip="Visa urval för kodbehörigheten"
      testId="KodbehBtn"
    />
  ) : (
    <EDButton
      color="primary"
      disabled={disabled}
      flat
      onClick={props.onClick}
      size="medium"
      icon={
        <EDIcon color={disabled ? 'disabled' : 'primary'} iconType="info" />
      }
      label={'Mina kodbehörigheter'}
      tooltip="Visa urval för kodbehörigheten"
      testId="KodbehBtn"
    />
  );
};

export default ShowKodBehButton;
